import Button from 'components/forms/Button'
import imageResize from 'project/image-proxy-web'
import useWindowSize from 'components/util/useWindowSize'
import useShoppingBag from 'common/useShoppingBag'
import { ButtonType } from '../../../types/global'
import { useRouter } from 'next/router'
import Strings from 'project/localisation'
import ImageCard from 'components/cards/base/ImageCard'
const options = [
  {
    description:
      'Buy the add-on at check-out (or at any point after you have your subscription) and have all of your business mail forwarded to you within 1 business day. You get all of the benefits including your virtual office address, our mail processing, handling and scanning with the added element of having all of your physical mail forwarded to you. <br/> <br/> This is the best option for anyone who wants to keep physical copies of their mail.',
    title: 'Add-on: Full mail forwarding service.',
  },
  {
    description: `Once you have a subscription with us, you can simply have individual pieces of mail forwarded at a per item cost. This is a great option to use for only the most important mail items, and can be paid for as you need it. Once you have purchased your plan subscription with us, you simply top-up your credits and choose which mail item you want forwarding and we'll send it to you that within one business day. If it's important mail, we will send it to you.`,
    title: 'Pay as you go: For occasional mail forwarding needs.',
  },
  {
    description: `Our final option for physical mail is that you come and collect it from our central London office between 9 a.m. – 6 p.m., Monday to Friday. Our dedicated reception team will be there to ensure you get your mail, don't forget to bring ID and only registered individuals can collect mail from us in person. We keep all mail for 30-days before we have it securely destroyed.`,
    title: 'Collection: Come and pick up your mail.',
  },
]

const MailForwardingOptions = ({ planSummary }) => {
  const size = useWindowSize()
  const { addPlan } = useShoppingBag()
  const router = useRouter()
  const onBuyClick = () => {
    addPlan(
      planSummary.slug,
      'year',
      planSummary,
      ButtonType.MAIL_FORWARDING_OPTIONS_CARD,
    )
    router.push('/checkout')
  }

  return (
    <div>
      <h2 className='fw-semibold fs-fluid-36-80 lh-105 text-center mb-6 mb-lg-15'>
        Mail forwarding options <br className='d-none d-lg-block' /> with the
        Hoxton Mix.
      </h2>
      <ImageCard
        shadow={false}
        reverseColumnsMobile
        verticalAlign='center'
        padding='0'
        imageAlt={`${Strings.companyFormation}`}
        imageLeft
        image='/images/new/cool-robot-handing-envelops.png'
        imageDimensions={{
          height: 947,
          width: 696,
        }}
        classNameForCol1='col-lg-12 col-xxl-6 pe-xxl-14 px-6'
        classNameForCol2='col-lg-6 offset-xxl-0 offset-lg-3 col-xl-6 ps-xxl-18'
      >
        {!size.isLgOrHigher && (
          <>
            {/*fs is always 20*/}
            <span className='fs-20 fw-bold text-center mt-n6'>
              Sign up for a virtual office plan today.
            </span>
            <Button
              onClick={onBuyClick}
              className='w-100 w-lg-auto align-self-start mt-6'
            >
              Buy Now
            </Button>
          </>
        )}
        <div className='d-flex flex-1 flex-column gap-3 gap-lg-5 me-xl-n15'>
          <span className='fw-semibold lh-119 fs-fluid-24-32'>
            For all of the following options, you will need a virtual office
            subscription.
            <br />
            <br />
            Mail forwarding is not available as a standalone service.
          </span>

          {options.map((option) => (
            <div className='lh-114' key={option.title}>
              <h3 className='fs-lg-24 mb-1 mb-lg-1'>{option.title}</h3>
              <p
                className='fs-lg-20 fw-semibold color-grey5 mb-0'
                dangerouslySetInnerHTML={{ __html: option.description }}
              />
            </div>
          ))}
          {size.isLgOrHigher && (
            <>
              {/*fs is always 20*/}
              <span className='fs-20 fw-bold'>
                Sign up for a virtual office plan today.
              </span>
              <Button onClick={onBuyClick} className='align-self-start'>
                Buy Now
              </Button>
            </>
          )}
        </div>
      </ImageCard>
    </div>
  )
}

export default MailForwardingOptions
